import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import i18n from 'i18next';
import { useSelector } from 'react-redux';
import { TablePagination } from '@material-ui/core';
import cx from 'classnames';
import PopupDialog from 'ui/components/popup-dialog';
import DropDown from '../ui/react-ui/dropdown';
import DataTable from '../ui/table';
import SearchBar from '../ui/searchBar';
import TermianlBoardEdit from './terminalBoard-edit'; // api

import { getTerminalBoardList, deleteMultipleTerminalBoardAPI } from '../../api/settingAPI';
var t = i18n.getFixedT(null, 'setting-terminalBoard');
var gt = i18n.getFixedT(null, 'app');
var TerminalBoard = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      terminalsList = _useSelector.app.terminalsList;

  var id = props.id;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      currentTerminalId = _useState2[0],
      setCurrentTerminalId = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      totalCount = _useState4[0],
      setTotalCount = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      currentPage = _useState6[0],
      setCurrentPage = _useState6[1];

  var _useState7 = useState(10),
      _useState8 = _slicedToArray(_useState7, 2),
      rowsPerPage = _useState8[0],
      setRowsPerPage = _useState8[1];

  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2),
      keyword = _useState10[0],
      setKeyword = _useState10[1];

  var _useState11 = useState({}),
      _useState12 = _slicedToArray(_useState11, 2),
      tableData = _useState12[0],
      setTableData = _useState12[1];

  var _useState13 = useState({
    field: 'beginTime',
    desc: true
  }),
      _useState14 = _slicedToArray(_useState13, 2),
      tableSort = _useState14[0],
      setTableSort = _useState14[1];

  var _useState15 = useState([]),
      _useState16 = _slicedToArray(_useState15, 2),
      selectedItems = _useState16[0],
      setSelectedItems = _useState16[1];

  var initDialogData = {
    mode: '',
    data: {}
  };

  var _useState17 = useState(initDialogData),
      _useState18 = _slicedToArray(_useState17, 2),
      dialogData = _useState18[0],
      setDialogData = _useState18[1];

  var handleOpenDialog = function handleOpenDialog(mode) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setDialogData({
      mode: mode,
      data: data
    });
  };

  var handleCloseDialog = function handleCloseDialog(act) {
    setDialogData(initDialogData);
    if (act === 'confirm') fetchTerminalBoardList();
  };

  var handleDelete = function handleDelete(singleId) {
    var deleteItems = [];
    if (singleId) deleteItems.push(singleId);else _.forEach(selectedItems, function (id) {
      return deleteItems.push(id);
    });
    PopupDialog.confirm({
      title: t('dlg-delete-terminalBoard'),
      display: t('txt-delete-terminalBoard'),
      cancelText: gt('global.lbl-answer-cancel'),
      confirmText: gt('global.lbl-answer-ok'),
      act: function act(confirmed) {
        if (confirmed) {
          deleteMultipleTerminalBoardAPI(contextRoot, false, deleteItems).then(function (result) {
            fetchTerminalBoardList();
            setSelectedItems([]);
          });
        }
      }
    });
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var fetchTerminalBoardList = function fetchTerminalBoardList() {
    var offset = (Number(currentPage + 1) - 1) * rowsPerPage;
    getTerminalBoardList(contextRoot, false, keyword, tableSort, offset, rowsPerPage, currentTerminalId).then(function (result) {
      if (result.totalElements !== totalCount) setTotalCount(result.totalElements);

      var newData = _.cloneDeep(result.content);

      _.map(newData, function (el, index) {
        el.sequence = offset + index + 1;
      });

      setTableData(newData);
    });
  };

  useEffect(function () {
    fetchTerminalBoardList();
  }, [keyword, JSON.stringify(tableSort), currentPage, rowsPerPage, currentTerminalId]);
  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'terminalId', {
    label: t('lbl-terminal'),
    sortable: true,
    formatter: function formatter(val, row) {
      var type = _.find(terminalsList, function (e) {
        return e.value === val;
      });

      return _.isEmpty(type) ? '' : type.text;
    }
  });

  _.set(fields, 'title', {
    label: t('lbl-title'),
    sortable: true
  });

  _.set(fields, 'description', {
    label: t('lbl-description'),
    sortable: true,
    formatter: function formatter(val, row) {
      if (_.isEmpty(val)) return null;

      var textAry = _.split(val, /\r?\n/g);

      return textAry.length > 1 ? textAry[0] + '...' : val;
    }
  });

  _.set(fields, 'createdAt', {
    label: t('lbl-createdAt'),
    sortable: true
  });

  _.set(fields, 'beginTime', {
    label: t('lbl-beginTime'),
    sortable: true
  });

  _.set(fields, 'endTime', {
    label: t('lbl-endTime'),
    sortable: true
  });

  _.set(fields, 'more', {
    label: t('lbl-more'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "icon-block"
      }, /*#__PURE__*/React.createElement("a", {
        title: t('lbl-edit'),
        onClick: function onClick() {
          return handleOpenDialog('edit', row);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-pencil-alt fa-list-alt"
      })), /*#__PURE__*/React.createElement("a", {
        title: t('lbl-delete'),
        onClick: function onClick() {
          return handleDelete(row.id);
        },
        className: "delete"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-trash"
      })));
    }
  });

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "terminalBoard-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, t('lbl-terminalboard-title')), /*#__PURE__*/React.createElement("div", {
    className: "selector"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label"
  }, t('lbl-terminal'), ": "), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-terminals'),
    list: terminalsList,
    value: currentTerminalId,
    onChange: function onChange(value) {
      setCurrentTerminalId(value);
      setCurrentPage(0);
    },
    width: '200px'
  }))), /*#__PURE__*/React.createElement("div", {
    className: "tooltip-bar"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    searchIconPosition: "right",
    placeholder: "Search",
    onSearch: function onSearch(search) {
      setKeyword(search);
    }
  }), /*#__PURE__*/React.createElement("a", {
    className: "create-terminalBoard-btn",
    onClick: function onClick() {
      return handleOpenDialog('create');
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-plus"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: tableData,
    sort: tableSort,
    onSort: function onSort(sort) {
      return setTableSort(sort);
    },
    rowIdField: "id",
    selectable: {
      toggleAll: true
    },
    selected: selectedItems,
    onSelectionChange: function onSelectionChange(val) {
      return setSelectedItems(val);
    }
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: gt('global.lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: function onChangePage(e, newPage) {
      return setCurrentPage(newPage);
    },
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }), /*#__PURE__*/React.createElement("div", {
    className: "footer"
  }, /*#__PURE__*/React.createElement("button", {
    className: cx('button', 'delete'),
    onClick: function onClick() {
      return handleDelete();
    },
    disabled: selectedItems.length > 0 ? false : true
  }, t('lbl-delete')))), /*#__PURE__*/React.createElement(TermianlBoardEdit, {
    dialogData: dialogData,
    onClose: handleCloseDialog
  }));
});
TerminalBoard.defaultProps = {
  id: 'g-setting-terminalBoard'
};
TerminalBoard.PropTypes = {
  id: PropTypes.string
};
export default TerminalBoard;